import toast from "react-hot-toast";
import { customDateFormatType } from "../../utils/utils";

const { clientAPI } = require("../client");
export const brokerDebtCertificateCall = {
  create: async (data) => {
    try {
      const response = await clientAPI("post", "/brokerDebtCertificate", data);
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  update: async (id, data) => {
    try {
      const response = await clientAPI("put", `/brokerDebtCertificate/${id}`, data);
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  delete: async (id) => {
    try {
      const response = await clientAPI("delete", `/brokerDebtCertificate/${id}`);
      return response;
    } catch (error) {
      console.error("Delete error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  import: async (input, name) => {
    try {
      const data = {
        input,
        name,
      };
      const response = await clientAPI(
        "post",
        "/brokerDebtCertificate/import/",
        data
      );
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  importCheck: async (input, name) => {
    try {
      const data = {
        input,
        name,
      };
      const response = await clientAPI(
        "post",
        "/brokerDebtCertificate/importCheck/",
        data
      );
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  recalculateAmountHeld: async ({ employeeId } = {}) => {
    try {
      const body = {};
      if (employeeId) body.employeeId = employeeId;
      const response = await clientAPI(
        "post",
        "/brokerDebtCertificate/recalculate-amount-held",
        body
      );
      return response;
    } catch (error) {
      console.error("Recalculate amountHeld error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];
      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  /**
   * Import CCMG theo đợt × căn × nhân viên (ghi DB).
   * Gọi sau khi importByPeriodCheck đã pass.
   * @param {Array} input - Danh sách { employeeCode, employeeName, apartmentCode, period, amountHeld }
   * @param {string} name - Tên file gốc (dùng cho log lỗi)
   */
  importByPeriod: async (input, name) => {
    try {
      const response = await clientAPI(
        "post",
        "/brokerDebtCertificate/import-by-period",
        { input, name },
      );
      return response;
    } catch (error) {
      console.error("importByPeriod error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
        error?.response?.statusText ||
        error?.message ||
        "An unexpected error occurred.",
      ];
      errorMessages.forEach((message) => toast.error(`${message}`));
      throw error;
    }
  },

  /**
   * Dry-run kiểm tra file import CCMG theo đợt — không ghi DB.
   * Trả về { successCount, failedCount, path, filename } để FE hiển thị.
   * @param {Array} input - Danh sách dữ liệu đã parse từ file Excel
   * @param {string} name - Tên file gốc (dùng cho tên file log lỗi)
   */
  importByPeriodCheck: async (input, name) => {
    try {
      const response = await clientAPI(
        "post",
        "/brokerDebtCertificate/import-by-period-check",
        { input, name },
      );
      return response;
    } catch (error) {
      console.error("importByPeriodCheck error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
        error?.response?.statusText ||
        error?.message ||
        "An unexpected error occurred.",
      ];
      errorMessages.forEach((message) => toast.error(`${message}`));
      throw error;
    }
  },

  /**
   * Kiểm tra dữ liệu Excel có khớp với BrokerDebtCertificate trong DB không.
   * Không ghi DB — so sánh amountHeld / amountPaid / amountActualRemaining.
   * @param {Array} input - Danh sách { employeeCode, employeeName, amountHeld, amountPaid, amountActualRemaining }
   * @param {string} name - Tên file gốc (dùng cho tên file log lỗi)
   */
  importDataCheck: async (input, name) => {
    try {
      const response = await clientAPI(
        "post",
        "/brokerDebtCertificate/import-data-check",
        { input, name },
      );
      return response;
    } catch (error) {
      console.error("importDataCheck error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
        error?.response?.statusText ||
        error?.message ||
        "An unexpected error occurred.",
      ];
      errorMessages.forEach((message) => toast.error(`${message}`));
      throw error;
    }
  },

  /**
   * Lịch sử CCMG theo đợt của một nhân viên.
   * @param {string} employeeId
   * @param {{ page?: number, limit?: number }} options
   */
  getPeriodList: async (employeeId, { page = 1, limit = 20 } = {}) => {
    try {
      const queryParams = new URLSearchParams({ employeeId, page, limit }).toString();
      const response = await clientAPI("get", `/brokerDebtCertificate/period-list?${queryParams}`);
      return response;
    } catch (error) {
      console.error("getPeriodList error:", error);
      const errorMessages = error?.response?.data?.errors?.map((e) => e.message) || [
        error?.response?.data?.message || error?.message || "An unexpected error occurred.",
      ];
      errorMessages.forEach((message) => toast.error(`${message}`));
      throw error;
    }
  },

  export: async (param) => {
    try {
      const options = {};

      if (param.search !== undefined) options.search = param.search;
      if (param.employeeId) options.employeeId = param.employeeId;
      if (param.startTime)
        options.startTime = customDateFormatType(param.startTime);
      if (param.endTime) options.endTime = customDateFormatType(param.endTime);

      const queryParams = new URLSearchParams(options).toString();

      const response = await clientAPI(
        "get",
        `/brokerDebtCertificate/export?${queryParams}`
      );

      const dataExport = response?.exportData;

      return dataExport;
    } catch (error) {
      console.error("get list error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
};